const DEFAULT_ROOT_DOMAIN = (process.env.REACT_APP_PUBLIC_ROOT_DOMAIN || 'sessionmonkey.com').toLowerCase();
const RESERVED_SUBDOMAINS = new Set(
  String(process.env.REACT_APP_RESERVED_SUBDOMAINS || 'app,www,api,admin')
    .split(',')
    .map((value) => value.trim().toLowerCase())
    .filter(Boolean),
);

const isLocalHost = (hostname: string) => hostname === 'localhost' || hostname.endsWith('.localhost');
const isIpHost = (hostname: string) => /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname);

const sanitizeSiteName = (siteName: string) => String(siteName || '').trim().toLowerCase();

export const getClubSiteSlugFromHostname = (hostname = window.location.hostname): string | null => {
  const host = String(hostname || '').toLowerCase().trim();
  if (!host || isIpHost(host)) return null;

  if (isLocalHost(host)) {
    if (host === 'localhost') return null;
    const label = host.slice(0, -'.localhost'.length);
    if (!label || label.includes('.')) return null;
    if (RESERVED_SUBDOMAINS.has(label)) return null;
    return label;
  }

  if (host === DEFAULT_ROOT_DOMAIN || host === `www.${DEFAULT_ROOT_DOMAIN}`) {
    return null;
  }

  const suffix = `.${DEFAULT_ROOT_DOMAIN}`;
  if (!host.endsWith(suffix)) return null;
  const candidate = host.slice(0, -suffix.length);
  if (!candidate || candidate.includes('.')) return null;
  if (RESERVED_SUBDOMAINS.has(candidate)) return null;
  return candidate;
};

export const getClubSiteUrl = (siteName: string): string => {
  const slug = sanitizeSiteName(siteName);
  if (!slug) return '';

  const protocol = window.location.protocol;
  const hostname = window.location.hostname.toLowerCase();
  const port = window.location.port;

  if (isLocalHost(hostname)) {
    const portSuffix = port ? `:${port}` : '';
    return `${protocol}//${slug}.localhost${portSuffix}`;
  }

  if (hostname === DEFAULT_ROOT_DOMAIN || hostname.endsWith(`.${DEFAULT_ROOT_DOMAIN}`)) {
    return `${protocol}//${slug}.${DEFAULT_ROOT_DOMAIN}`;
  }

  return `${window.location.origin}/clubs/${encodeURIComponent(slug)}`;
};

export const getClubSiteHref = (siteName: string): string => {
  const slug = sanitizeSiteName(siteName);
  if (!slug) return '/clubs';
  const absoluteUrl = getClubSiteUrl(slug);
  if (!absoluteUrl) return '/clubs';
  return absoluteUrl;
};

export const getMarketingSiteHref = (): string => {
  const explicitUrl = String(process.env.REACT_APP_MARKETING_SITE_URL || '').trim();
  if (explicitUrl) {
    return explicitUrl;
  }

  const protocol = window.location.protocol;
  const hostname = window.location.hostname.toLowerCase();

  if (isLocalHost(hostname) || isIpHost(hostname)) {
    return `${protocol}//localhost:3000`;
  }

  return `${protocol}//${DEFAULT_ROOT_DOMAIN}`;
};
